import { useState } from 'react';
import InputMask from 'react-input-mask';
import { isValidPhoneNumber } from '../../common/phoneInputValid';

export const InputPhone = ({
    id,
    name,
    label,
    onChange,
    value,
    placeholder,
    disabled = false,
    error = null,
    required = false,
}) => {
    const [touched, setTouched] = useState(false);

    const showValidation = touched && required && !error;
    const digits = (value || '').replace(/\D/g, '');
    let validationMessage = null;
    if (showValidation) {
        if (digits.length === 0) validationMessage = 'Este campo es requerido';
        else if (!isValidPhoneNumber(value || '')) {
            validationMessage = 'El número de teléfono debe contener exactamente 10 dígitos.';
        }
    }
    const displayError = error || validationMessage;

    return (
        <div className="w-full">
            {label && (
                <label htmlFor={id} className="block text-sm font-semibold text-gray-700 mb-2 ml-1">
                    {label}
                    {required && (
                        <span className="text-red-500 ml-1" aria-hidden="true">
                            *
                        </span>
                    )}
                </label>
            )}
            <div className="mt-0">
                <InputMask
                    className={`
                        block w-full rounded-xl border-2 py-2.5 px-4 sm:text-sm sm:leading-6 outline-none transition-all duration-300
                        disabled:bg-gray-50 disabled:cursor-not-allowed
                        ${displayError
                            ? 'border-red-500 bg-red-50 text-red-900 placeholder:text-red-400 focus:ring-4 focus:ring-red-100'
                            : 'border-gray-200 bg-white placeholder:text-gray-400 hover:border-gray-300 focus:border-indigo-600 focus:bg-indigo-50/50 focus:ring-4 focus:ring-indigo-100'
                        }
                    `}
                    id={id}
                    name={name}
                    mask="(999) 999 9999"
                    maskPlaceholder=""
                    type="tel"
                    onChange={onChange}
                    onBlur={() => setTouched(true)}
                    value={value}
                    placeholder={placeholder}
                    disabled={disabled}
                    aria-invalid={displayError ? true : undefined}
                    aria-required={required || undefined}
                />
            </div>
            {displayError && (
                <p className="mt-2 text-sm text-red-600 flex items-center gap-1 ml-1">
                    <svg className="w-4 h-4 shrink-0" fill="currentColor" viewBox="0 0 20 20">
                        <path
                            fillRule="evenodd"
                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                            clipRule="evenodd"
                        />
                    </svg>
                    {displayError}
                </p>
            )}
        </div>
    );
};

// import { useState } from 'react';
// import InputMask from 'react-input-mask';

// export const InputPhone = ({ id, name, label, onChange, value, placeholder, disabled }) => {
//     const [error, setError] = useState('');

//     // Función para manejar el cambio de input y validar el número de teléfono
//     const handlePhoneChange = (e) => {
//         const rawValue = e.target.value.replace(/\D/g, ''); // Eliminar caracteres no numéricos
//         if (rawValue.length !== 10) {
//             setError('El número de teléfono debe contener exactamente 10 dígitos.');
//         } else {
//             setError('');
//         }
//         onChange(e);
//     };

//     return (
//         <div>
//             <label htmlFor={name} className="block text-md font-semibold text-gray-900 leading-6 ml-1">
//                 {label}
//             </label>
//             <div className="mt-2">
//                 <InputMask
//                     className="block w-full focus:bg-indigo-50 rounded-md border-0 py-2 px-4 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
//                     id={id}
//                     name={name}
//                     mask="(999) 999 9999"
//                     maskPlaceholder=""
//                     type="tel"
//                     onChange={handlePhoneChange}
//                     value={value}
//                     placeholder={placeholder}
//                     disabled={disabled}
//                 />
//             </div>
//             {error && (
//                 <p className="text-red-500 text-sm mt-1">
//                     {error}
//                 </p>
//             )}
//         </div>
//     );
// };
